import PropTypes from "prop-types";
import React from "react";
import SectionTitle from "../../../components/UI/section-title/section-title-one";
import pricingData from "../../../data/pricing-tables/pricing-table-one.json";
import PricingTableOneSingle from "../../../components/pricing-tables/pricing-table-one/index.js";
import bgImg from "./../../../assets/images/bg/1.jpg";
import styles from "./PricingTableOne.module.scss";

const PricingTableOne = ({ background }) => {
  return (
    <div
      className="voopo__picing__area pt--120 pb--120 bgImg" id="plans"
      style={
        background === "none"
          ? { background: `none` }
          : { backgroundImage: `url(${bgImg})` }
      }
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            {/* section title */}
            <SectionTitle title="Package" text="Pick a Pricing Plan" />
          </div>
        </div>
        <div className="row mt--30">
          {pricingData &&
            pricingData.map((single, key) => {
              return (
                <PricingTableOneSingle
                  data={single}
                  key={key}
                  styles={styles}
                />
              );
            })}
            <p style={{textAlign: 'center', marginTop: '25px', fontSize: '13px'}}>Prices shown are “starting from” rates. Actual pricing, speeds, and availability vary by provider and location. Taxes and fees may apply.</p>
        </div>
      </div>
    </div>
  );
};

PricingTableOne.propTypes = {
  background: PropTypes.string
};

export default PricingTableOne;
